import React from "react";
import { Box, Typography } from "@mui/material";

export default function Footer({ open }) {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: open ? 240 : 72, // mengikuti lebar sidebar
        width: `calc(100% - ${open ? 240 : 72}px)`,
        textAlign: "center",
        py: 1.5,
        backgroundColor: "#FAFAFA",
        borderTop: "1px solid #E5E7EB",
        fontSize: 13,
        zIndex: 1200,
        transition: "all 0.3s ease",
      }}
    >
      <Typography variant="body2" color="black">
        © 2025 <strong>PORTAL DATA v.1.2.0</strong> | Dikembangkan oleh IT Dev
        Pusdatinhub DKI Jakarta. Seluruh hak cipta dilindungi.
      </Typography>
    </Box>
  );
}
